<template>
    <div class="home">
        <div style="min-height: 5.6rem;"></div>
        <section class="banner hidden-xs-only" :style="banners.length==0?'height:0':''" data-aos="fade-up" data-aos-duration="1000">
            <div class="banner-swiper-container" >
                <div class="swiper-wrapper">
                    <div
                        v-for="item of banners"
                        :key="item.id"
                        class="swiper-slide"
                    >
                        <img onerror="this.src='/imgs/queshengye_b.png'" :src="item.image?item.image:'/imgs/queshengye_a.png'" alt="" />
                    </div>
                </div>
                <div class="swiper-pagination"></div>
            </div>
        </section>
        <div class="hidden-xs-only nobanner"  :style="banners.length>0?'height:0':''">
            <img   src="/imgs/queshengye_a.png" alt="">
        </div>
        
        <section class="banner hidden-sm-and-up" :style="banners_mobile.length==0?'height:0':''" data-aos="fade-up" data-aos-duration="1000">
            <div class="banner-swiper-container">
                <div class="swiper-wrapper">
                    <div
                        v-for="item of banners_mobile"
                        :key="item.id"
                        class="swiper-slide"
                    >
                        <img onerror="this.src='/imgs/queshengye_b.png'" :src="item.image?item.image:'/imgs/queshengye_a.png'" alt="" />
                    </div>
                </div>
                <div class="swiper-pagination"></div>
            </div>
        </section>
        <div class="hidden-sm-and-up nobanner2"  :style="banners_mobile.length>0?'height:0':''">
            <img   src="/imgs/queshengye_a.png" alt="">
        </div>

        <section class="product" data-aos="fade-up" data-aos-duration="2000">
            <div class="title">
                <span></span>
                <h3>产品及</h3>
                <h3>解决方案</h3>
                <div class="to-view-more  hidden-xs-only" style="margin-top: 4.5rem;" @click="handleProduct">
                    查看更多 <i class="el-icon-arrow-right"></i>
                </div>
            </div>
            <div class="product-swiper hidden-xs-only">
                <div :style="productArrow?'margin-left:-51rem;':'margin-left:0;'">
                    <div v-for="item of product" :key="item.id"  class="product-swiper-item" @click="handleProductDetail(item)">
                        <div class="product-cover"><img  :src="item.cover" alt="" /></div>
                        <div class="product-name">
                            <div></div>
                            <h3>{{item.name}}</h3>
                            <span>{{item.desc}}</span>
                        </div>
                    </div>
                </div>
                <span v-show="product.length>2" class="product-swiper-arrow" @click="handleProductArrow(productArrow)"><i :class="!productArrow?'el-icon-arrow-right':'el-icon-arrow-left'"></i></span>
            </div>
            <div class="product-swiper-xs hidden-sm-and-up">
                <div class="product-swiper-container">
                    <div class="swiper-wrapper">
                        <div v-for="item of product" :key="item.id"  class="swiper-slide" @click="handleProductDetail(item)">
                            <div  class="product-item">
                                <div class="product-cover"><img  :src="item.cover" alt="" /></div>
                                <div class="product-name">
                                    <div></div>
                                    <h3>{{item.name}}</h3>
                                    <span>{{item.desc}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- 如果需要分页器 -->
                    <!-- <div class="swiper-pagination"></div> -->
                    <!-- 如果需要导航按钮 -->
                    <div class="swiper-button-prev"></div>
                    <div class="swiper-button-next"></div>
                </div>
            </div>
            <div class="hidden-sm-and-up" style="width:100%;display:flex;justify-content: center;">
                <div class="to-view-more " style="margin-top: 4.5rem;" @click="handleProduct">
                    查看更多 <i class="el-icon-arrow-right"></i>
                </div>
            </div>
        </section>

        <section class="news" data-aos="fade-up" data-aos-duration="2000">
            <div class="news-title">
                <div class="title">
                    <span></span>
                    <h3>新闻动态</h3>
                </div>
            </div>
            <div class="news-list" v-if="news.length>0">
                <div class="news-left-item" @click="handleNewsDetail(news[0])">
                    <div class="news-left-item-cover">
                        <img onerror="this.src='/imgs/queshengye_b.png'" :src="news[0].coverImg?news[0].coverImg:'/imgs/queshengye_a.png'" alt="">
                    </div>
                    <div class="news-left-item-desc">
                        <h3>{{news[0].title}}</h3>
                        <p><span class="notify"></span> {{news[0].label==10?'公司动态':news[0].label==20?'行业动态':news[0].label==30?'成功案例':''}}</p>
                        <p><span class="time"></span> {{news[0].publishTime?news[0].publishTime.substr(0,10):''}}</p>
                        <p class="desc">{{news[0].briefly}}</p>
                        <div></div>
                    </div>
                </div>
                <div class="news-right-item hidden-xs-only">
                    <div v-for="(item,idx) of news" :key="item.id">
                        <div v-show="idx>0" class="news-right-item-i" @click="handleNewsDetail(item)">
                            <div class="news-right-item-i-content">
                                <p><span>{{item.label==10?'公司动态':item.label==20?'行业动态':item.label==30?'成功案例':''}}</span><span style="margin:0 10px">|</span><span>{{item.publishTime?item.publishTime.substr(0,10):''}}</span></p>
                                <h3>{{item.title}}</h3>
                            </div>
                            <div class="hover-bg"></div>
                        </div>
                    </div>
                    <div class="more">
                        <div class="to-view-more" @click="handleNews">
                            查看更多 <i class="el-icon-arrow-right"></i>
                        </div>
                    </div>
                </div>
                <div class="news-right-item hidden-sm-and-up" style="width:43rem;">
                    <div v-for="(item,idx) of news" :key="item.id">
                        <div v-show="idx>0" class="news-right-item-i" @click="handleNewsDetail(item)">
                            <div class="news-right-item-i-content">
                                <p><span>{{item.label==10?'公司动态':item.label==20?'行业动态':item.label==30?'成功案例':''}}</span><span style="margin:0 10px">|</span><span>{{item.publishTime?item.publishTime.substr(0,10):''}}</span></p>
                                <h3>{{item.title}}</h3>
                            </div>
                            <div class="hover-bg"></div>
                        </div>
                    </div>
                    <div v-show="news.length<5" class="more">
                        <div class="to-view-more" @click="handleNews">
                            查看更多 <i class="el-icon-arrow-right"></i>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section v-show="course.length>0" class="course" data-aos="fade-up" data-aos-duration="2000">
            <div class="course-title">
                <div class="title">
                    <span></span>
                    <h3>成功案例</h3>
                </div>
            </div>
            <div class="course-list">
                <div class="course-swiper-container">
                    <div class="swiper-wrapper">
                        <div
                            v-for="item of course"
                            :key="item.id"
                            class="swiper-slide"
                        >
                            <div class="course-item">
                                <div class="course-item-cover">
                                    <img onerror="this.src='/imgs/queshengye_b.png'" :src="item.coverImg?item.coverImg:'/imgs/queshengye_a.png'" alt="">
                                    <div class="hidden-xs-only"></div>
                                </div>
                                <div class="course-item-desc">
                                    <div class="course-item-desc-title">
                                        <h3>
                                            <p :title="item.title">{{item.title}}</p>
                                            <span></span>
                                        </h3>
                                        <p>{{item.briefly}}</p>
                                    </div>
                                    <div class="to-view-more" @click="handleSuccessfulDetail(item)">
                                        查看完整案例
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- 如果需要分页器 -->
                    <div class="swiper-pagination"></div>
                </div>
            </div>
            <div v-show="course.length>=3" class="more">
                <div class="to-view-more" @click="handleSuccessful">
                    查看更多 <i class="el-icon-arrow-right"></i>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import { 
    getHomepageNewsAndEvents,
    getHomepageSuccessStories,
    getHomepageCarousels,
    getHomepageNewsList
} from '@/utils/api.js'
import Swiper from "swiper";
export default {
    name: "Home",
    components: {},
    data() {
        return {
            banners: [],
            banners_mobile: [],
            product:[
                {
                    id:'cxxt02',
                    cover:"/imgs/home/shouye_zhinengcaixuexiterhaxilie.png",
                    name:"智能采血系统02系列",
                    desc:"解放双手·把时间留给服务"
                },
                {
                    id:'cxxt01',
                    cover:"/imgs/home/shouye_zhinengcaixueyihaoxilie.png",
                    name:"智能采血系统01系列",
                    desc:"解放双手·把时间留给服务"
                },
                {
                    id:'jkzx',
                    cover:"/imgs/home/shouye_jiankangzhengxunxit.png",
                    name:"智能健康征询系统",
                    desc:"一站检测·简易方便"
                },
                {
                    id:'czpt',
                    cover:"/imgs/home/shouye_zhinengshoutuiche.png",
                    name:"智能移动操作平台",
                    desc:"专注血液安全·守护生命健康"
                },
            ],
            productArrow:false,
            news:[],
            course:[],
        };
    },
    methods: {
        handleProductArrow(e){
            this.productArrow=!e
        },
        handleProduct(){
            this.$router.push('/product');
        },
        handleProductDetail(e){
            this.$router.push('/'+e.id+'?nav=Product')
        },
        handleNews(){
            this.$router.push('/news/0');
        },
        handleNewsDetail(e){
            this.$router.push('/newsDetail/'+e.id+"?label=0&nav=News")
        },
        handleSuccessful(){
            this.$router.push('/successful');
        },
        handleSuccessfulDetail(e){
            this.$router.push('/newsDetail/'+e.id+"?label=30&nav=Successful")
        },
        getNews(){
            const params={
                current:1,
                size:5,
                labelList:"10,20"
            }
            getHomepageNewsList(params).then(res=>{
                if(res.data.code == 10000){
                    let data = res.data.data
                    this.news = data.records
                }
            })
        },
        getSuccess(){
            const params={
                current:1,
                size:3,
                labelList:"30"
            }
            getHomepageNewsList(params).then(res=>{
                if(res.data.code == 10000){
                    let data = res.data.data
                    this.course = data.records 
                    this.$nextTick(()=>{
                        new Swiper(".course-swiper-container", {
                            loop: true,
                            autoplay: 3000,
                            pagination: ".swiper-pagination",
                            paginationClickable:true,
                        });
                    })
                }
            })
        },
        GETHomepageCarousels(){
            getHomepageCarousels().then(res=>{
                if(res.data.code == 10000){
                    const data = res.data.data
                    let banners = []
                    let banners_mobile = []
                    for(let v of data){
                        if(v.type==10){
                            banners.push(v)
                        }else{
                            banners_mobile.push(v)
                        }
                    }
                    
                    this.banners = banners 
                    this.banners_mobile = banners_mobile 

                    this.$nextTick(()=>{
                        new Swiper(".banner-swiper-container", {
                            loop: true,
                            autoplay: 3000,
                            // 如果需要分页器
                            pagination: ".swiper-pagination",
                            paginationClickable:true,
                            // 如果需要前进后退按钮
                            // nextButton: '.swiper-button-next',
                            // prevButton: '.swiper-button-prev',
                            // 如果需要滚动条
                            // scrollbar: '.swiper-scrollbar',
                            //如果需要自动切换海报
                            // autoplay: {
                            //   delay: 1000,//时间 毫秒
                            //   disableOnInteraction: false,//用户操作之后是否停止自动轮播默认true
                            // },
                        });
                    })
                }
            })
        }
    },
    created() {
        document.title = "深圳市傲天医疗智能系统有限公司-首页"
    },
    mounted() {
        new Swiper(".product-swiper-container", {
            nextButton: '.swiper-button-next',
            prevButton: '.swiper-button-prev',
        });

        this.getNews()
        this.getSuccess()
        this.GETHomepageCarousels()
    },
};
</script>
<style lang="less" scoped>
.home {
    padding-bottom:7.7rem;
    position: relative;
    .banner {
        max-height: calc(100vh - 5.6rem);
        overflow: hidden;
        .banner-swiper-container {
            width: 100%;
            min-height: 25.8rem;
            .swiper-wrapper {
                width: 100%;
                height: 100%;
                min-height: 25.8rem;
                .swiper-slide {
                    width: 100%;
                    height: 100%;
                    min-height: 25.8rem;
                    img {
                        width: calc(100vw + 25px);
                        height: 100%;
                        min-height: 25.8rem;
                        object-fit: cover;
                    }
                }
            }
        }
    }
    .nobanner{
        width: 100%;
        height: calc(100vh - 5.6rem);
        overflow: hidden;
        display: flex;
        align-items: center;
        justify-content: center;
        img{
            width: 50vw;
        }
    }
    .nobanner2{
        width: 100%;
        height: 25.6rem;
        display:flex;
        align-items: center;
        justify-content: center;
        overflow: hidden;
        img{
            width: 100vw;
        }
    }
    .title {
        margin-bottom: 4.5rem;
        > h3 {
            margin: 0;
            font-size: 2.6rem;
        }
        > span {
            display: block;
            width: 5.6rem;
            height: 0.4rem;
            background: #0f45f9;
            margin-bottom: 1rem;
        }
    }
    .to-view-more {
        width: 11rem;
        height: 2.8rem;
        background: #ffffff;
        border: 2px solid #0f45f9;
        box-sizing: border-box;
        text-align: center;
        line-height: calc(2.8rem - 4px);
        font-size: 1.1rem;
        color: #0f45f9;
        cursor: pointer;
        transition: all 0.3s ease;
        background: transparent;
        &:hover {
            color: #fff;
            background: #0f45f9;
        }
        &:active {
            color: #fff;
            background: #0f45f9;
        }
    }
    .product {
        width: 67rem;
        max-width: calc(100vw - 40px);
        margin: 20px auto;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        margin-top: 7.7rem;
        .product-swiper {
            width: 50rem;
            height: 31rem;
            overflow: hidden;
            position: relative;
            display: flex;
            >div{
                transition: all 0.3s ease;
                display: flex;
                .product-swiper-item {
                    height: 31rem;
                    width: 25rem;
                    color: #000;
                    cursor: pointer;
                    transition: all  0.3s ease;
                    margin-right: 0.5rem;
                    .product-cover{
                        width: 25rem;
                        height: 25rem;
                        text-align: center;
                        line-height: 25rem;
                        background: #F7F7F7;
                        overflow: hidden;
                        img{
                            width: 25rem;
                            height: 25rem;
                            object-fit: contain;
                            transition: all 0.3s ease;
                        }
                    }
                    .product-name{
                        background: #E8E8E8;
                        height: 6rem;
                        width: 25rem;
                        position: relative;
                        h3{
                            position: relative;
                            margin: 0;
                            margin-left: 4rem;
                            padding-top: 1rem;
                            padding-bottom: 0.77rem;
                            font-size: 1.3rem;
                            z-index: 2;
                        }
                        span{
                            position: relative;
                            margin-left: 4rem;  
                            font-size: 0.88rem;
                            z-index: 2;
                        }
                        >div{
                            height: 0;
                            width: 25rem;
                            position: absolute;
                            left: 0;
                            bottom: 0;
                            z-index: 1;
                            background: #0f45f9;
                            transition: all 0.3s ease;
                        }
                    }
                    &:hover{
                        .product-name{
                            color: #fff;
                            >div{
                                height: 6rem;
                            }
                        }
                        .product-cover{
                            img{
                                width: 26rem;
                                height: 26rem;
                                object-fit: contain;
                                margin-left:-10px;
                                margin-top:-10px
                            }
                        }
                    }
                }
            }

            .product-swiper-arrow{
                position: absolute;
                right: 0;
                bottom: 0;
                z-index: 3;
                display: block;
                width: 50px;
                height: 50px;
                background: #002AB8;
                text-align: center;
                line-height: 50px;
                color: #fff;
                font-size: 18px;cursor: pointer;
            }
        }
        .product-swiper-xs{
            width: calc(100vw - 40px);
            margin: 20px auto;
            .product-swiper-container {
                height: 120vw;
                width: 100%;
                overflow: hidden;
                position: relative;
                .swiper-wrapper {
                    width: 100%;
                    height: 100%;
                    .swiper-slide {
                        width: 100%;
                        height: 100%;
                        .product-item{
                            color: #000;
                            cursor: pointer;
                            transition: all  0.3s ease;
                            .product-cover{
                                width: 100vw;
                                height: 100vw;
                                text-align: center;
                                line-height: 100vw;
                                background: #F7F7F7;
                                overflow: hidden;
                                img{
                                    width: 100vw;
                                    height: 100vw;
                                    object-fit: contain;
                                    transition: all 0.3s ease;
                                }
                            }
                            .product-name{
                                background: #E8E8E8;
                                height: 20vw;
                                width: 100vw;
                                position: relative;
                                h3{
                                    position: relative;
                                    margin: 0;
                                    margin-left: 5rem;
                                    padding-top: 1rem;
                                    padding-bottom: 0.77rem;
                                    font-size: 1.3rem;
                                    z-index: 2;
                                }
                                span{
                                    position: relative;
                                    margin-left: 5rem;  
                                    font-size: 0.8rem;
                                    z-index: 2;
                                }
                                >div{
                                    height: 0;
                                    width: 100vw;
                                    position: absolute;
                                    left: 0;
                                    bottom: 0;
                                    z-index: 1;
                                    background: #0f45f9;
                                    transition: all 0.3s ease;
                                }
                            }
                            &:hover{
                                .product-name{
                                    color: #fff;
                                    >div{
                                        height: 20vw;
                                    }
                                }
                            }
                        }

                    }
                }
            }
        }
    }
    .news{
        width: 67rem;
        max-width: calc(100vw - 40px);
        margin: 7.7rem auto;
        position: relative;
        .title{
            display: flex;
            flex-direction: column;
            align-items: flex-end;
        }
        .news-title{
            display: flex;
            flex-direction: row-reverse;
            .title{
                position: relative;
                right: 0;
            }
        }
        .news-list{
            display: flex;
            flex-wrap: wrap;
            justify-content: center;
            .news-left-item{
                width: 43rem;
                height: 42rem;
                max-width: calc(100vw - 40px);
                background: #FCFCFC;
                overflow: hidden;
                cursor: pointer;
                .news-left-item-cover{
                    width: 43rem;
                    max-width: calc(100vw - 40px);
                    height: 31rem;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    overflow: hidden;
                    img{
                        width: 100%;
                        transition: all 0.3s ease;
                    }
                }
                .news-left-item-desc{
                    height: 11rem;
                    position: relative;
                    overflow: hidden;
                    margin: 0;
                    >h3{
                        font-size: 1rem;
                        margin: 0 1.5rem;
                        padding: 0;
                        position: relative;
                        z-index: 2;
                        padding-top:1.5rem;

                    }
                    >p{
                        display: flex;
                        margin: 0.5rem 1.5rem;
                        color: #666666;
                        font-size: 0.77rem;
                        position: relative;
                        z-index: 2;
                        line-height: 1rem;
                        width: calc(100% - 3rem);
                        >span{
                            width: 1rem;
                            height: 1rem;
                            background-size: 100% 100%;
                            margin-right: 0.3rem;
                        }
                        .notify{
                            background-image: url('/imgs/notify1.png');
                        }
                        .time{
                            background-image: url('/imgs/time1.png');
                        }
                    }
                    >div{
                        position: absolute;
                        left: 0;
                        bottom: 0;
                        z-index: 1;
                        width: 43rem;
                        height: 0;
                        background: #0f45f9;
                        transition: all 0.3s ease;
                    }
                    .desc{
                        text-indent: 2em;
                        width: calc(100% - 3rem);
                        overflow: hidden;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-line-clamp: 2;
                        -webkit-box-orient: vertical;
                        color: #999999;
                        line-height: 1.2rem;
                    }
                }
                &:hover{
                    .news-left-item-cover{
                        img{
                            width: 120%;
                        }
                    }
                    .news-left-item-desc{
                        color:#fff;
                        >p{
                            color: #fff;
                            .notify{
                                background-image: url('/imgs/notify2.png');
                            }
                            .time{
                                background-image: url('/imgs/time2.png');
                            }
                        }
                        >div{
                            height: 11rem;
                        }
                    }
                }
                &:active{
                    .news-left-item-desc{
                        color:#fff;
                        >p{
                            color: #fff;
                            .notify{
                                background-image: url('/imgs/notify2.png');
                            }
                            .time{
                                background-image: url('/imgs/time2.png');
                            }
                        }
                        >div{
                            height: 11rem;
                        }
                    }
                }
            }
            .news-right-item{
                width: 24rem;
                max-width: calc(100vw - 40px);
                .news-right-item-i{
                    height: 7.7rem;
                    width: 100%;
                    overflow: hidden;
                    position: relative;
                    cursor: pointer;
                    .news-right-item-i-content{
                        box-sizing: border-box;
                        border-bottom: 2px solid #EEEEEE;
                        padding: 1rem 0;
                        margin: 0 1.5rem;
                        height: 100%;
                        display: flex;
                        flex-direction: column;
                        justify-content:center;
                        position: relative;
                        z-index: 2;
                        >p{
                            // margin: 0;
                            font-size: 14px;
                            color: #666666;
                        }
                        white-space: nowrap;
                        >h3{
                            width: 100%;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            font-size: 1rem;
                            margin: 0;
                        }
                    }
                    .hover-bg{
                        transition: all 0.3s ease;
                        width: 0;
                        height: 7.7rem;
                        bottom: 0;
                        left: 0;
                        position: absolute;
                        z-index: 1;
                        background: #0f45f9;
                    }
                    &:hover{
                        .news-right-item-i-content{
                            color: #fff;
                            border:none;
                            >p{
                                >span{
                                    color: #fff!important;
                                }
                            }
                        }
                        .hover-bg{
                            width: 100%;
                        }
                    }
                    &:active{
                        .news-right-item-i-content{
                            color: #fff;
                            border:none;
                            >p{
                                >span{
                                    color: #fff!important;
                                }
                            }
                        }
                        .hover-bg{
                            width: 100%;
                        }
                    }
                }
                .more{
                    height: 11rem;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }
            }
        }
    }
    .course{
        width: 67rem;
        max-width: calc(100vw - 40px);
        margin:0 auto;
        .course-title{
            width: 67rem;
            max-width: calc(100vw - 40px);
            margin: 20px auto;
        }
        .course-list{
            width: 67rem;
            max-width: calc(100vw - 40px);
            position: relative;
            border-radius: 1.5rem;
            display: flex;
            align-items: center;
            justify-content: center;
            background: #FFFFFF;
            box-shadow: 5px 0px 20px 0px rgba(15, 24, 55, 0.1);
            .course-swiper-container {
                width: 67rem;
                max-width: calc(100vw - 40px);
                border-radius: 1.5rem;
                overflow: hidden;
                .swiper-wrapper {
                    width: 100%;
                    .swiper-slide {
                        width: 67rem;
                        max-width: calc(100vw - 40px);
                        border-radius: 1.5rem;
                        overflow: hidden;
                        .course-item{
                            display: flex;
                            justify-content: center;
                            flex-wrap: wrap;
                            .course-item-cover{
                                width: 35.5rem;
                                max-width: calc(100vw - 40px);
                                overflow: hidden;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                position: relative;
                                box-shadow:0 0 50px 30px #ffffff inset;
                                position: relative;
                                overflow: hidden;
                                >img{
                                    border: none;
                                    width: 100%;
                                    height: 100%;
                                    object-fit: cover;
                                    position: relative;
                                    z-index: 1;
                                }
                                div{
                                    position: absolute;
                                    right: 0;
                                    top: 0;
                                    z-index: 2;
                                    width: 5rem;
                                    min-width: 5rem;
                                    height: 100%;
                                    background: linear-gradient(to left, #fff , transparent);
                                }
                            }
                            .course-item-desc{
                                width: 31.5rem;
                                max-width: calc(100vw - 40px);
                                height: 26.6rem;
                                display: flex;
                                flex-direction: column;
                                justify-content: space-between;
                                .course-item-desc-title{
                                    >h3{
                                        margin:4rem 5rem;
                                        // white-space: pre-line;
                                        >p{
                                            margin: 0;
                                            padding: 0;
                                            font-size: 1.4rem;
                                            overflow : hidden;
                                            text-overflow: ellipsis;
                                            display: -webkit-box;
                                            -webkit-line-clamp: 2;
                                            -webkit-box-orient: vertical;
                                        }
                                        >span{
                                            display: block;
                                            width: 6rem;
                                            height: 0.3rem;
                                            background: #0F45F9;
                                            margin-top:1rem;
                                        }
                                    }
                                    >p{
                                        margin: 0 5rem;
                                        color: #666666;
                                        font-size: 0.77rem;
                                        text-indent: 2em;
                                        overflow: hidden;
                                        text-overflow: ellipsis;
                                        display: -webkit-box;
                                        -webkit-line-clamp: 3;
                                        -webkit-box-orient: vertical;
                                    }
                                }

                                .to-view-more{
                                    margin:4rem 5rem;
                                }
                            }
                        }
                    }
                }
            }
        }
        .more{
            display: flex;
            align-items: center;
            justify-content: center;
            margin-top: 5rem;
        }
    }
}
</style>
